module.exports = __webpack_public_path__ + "img/vc.aa99fd1d.svg";